import { OpenSubmissionsElement } from 'communication/types/openSubmissions/OpenSubmissionsElement';
import { WidgetType } from 'widgets/WidgetType';
import {
    createReceiveMessageAction,
    createClearStreamDataAction,
    createWatchStreamAction,
} from 'widgets/store/stream/actions';

export const receiveMessageAction =
    createReceiveMessageAction<OpenSubmissionsElement>(
        WidgetType.OPEN_SUBMISSIONS_CAPSULE
    );

export const clearOpenSubmissionsCapsuleStreamData =
    createClearStreamDataAction(WidgetType.OPEN_SUBMISSIONS_CAPSULE);

export const watchOpenSubmissionsStreamAction = createWatchStreamAction(
    WidgetType.OPEN_SUBMISSIONS_CAPSULE
);
